import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Equalizer from "../../../../scripts/classes/Equalizer";

gsap.registerPlugin(ScrollTrigger);

var MapFloorPlansWithUnits = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-MapFloorPlansWithUnits',
  };

  $.extend(true, this.options, options);

};

MapFloorPlansWithUnits.prototype.init = function () {

  var self = this;

  this.$allPopupMarkers = self.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`);
  this.visiblePopupMarkerIds = [];
  this.hiddenPopupMarkerIds = [];
  this.activeFloor = 1;
  this.activePopupId = null;
  this.goToFloorTimeline = null;
  this.popupAnimation = null;
  this.hidePopupTimeout = null;

  // initially populate this.hiddenPopupMarkerIds with all marker IDs
  for (let i = 0; i < this.$allPopupMarkers.length; i++) {
    this.hiddenPopupMarkerIds.push(this.$allPopupMarkers.eq(i).data('popupId'));
  }

  // equalize floor name heights
  this.floorNamesEq = new Equalizer(self.options.$el.find(`.${self.options.baseClass}__floorIndicator__floorNames, .${self.options.baseClass}__floorIndicator__floorNames__floorName`));
  this.floorNamesEq.equalizeHeights();
  PubSub.subscribe("resized", function () {
    self.floorNamesEq.equalizeHeights();
  });

  // if unit url parameter exists, open modal on page load
  var currentUrl = window.location.href;

  if (currentUrl.indexOf("unitDetail")) {

    var urlSegments = currentUrl.split('?');

    if (urlSegments.length > 1) {

      var urlParameters = urlSegments[1].split('&');

      for (var i = 0; i < urlParameters.length; i++) {

        if (urlParameters[i].indexOf("unitDetail") == 0) {

          var unitId = urlParameters[i].split('=')[1];

          // make sure we don't open our modal onload from multiple components
          if (!window.unitDetailOpenedOnload) {
            window.unitDetailOpenedOnload = true;
            self.showUnitModalWhenLoaded(unitId);
          }

        }

      }

    }

  }

  this.initFilters();
  this.initUnitPopups();
  this.animateIn();

};

MapFloorPlansWithUnits.prototype.initFilters = function () {

  var self = this;

  this.options.$el.find(`.${self.options.baseClass}__selector--floor`).on('change', function () {

    self.goToFloor($(this).val());

  });

  this.options.$el.find(`.${self.options.baseClass}__selector--availability, .${self.options.baseClass}__selector--type`).on('change', function () {

    self.updateVisiblePopups();
    self.updateActiveFilters();

  });

  this.options.$el.find(`.${self.options.baseClass}__resetButton`).on('click', function () {

    self.options.$el.find(`.${self.options.baseClass}__selector--availability, .${self.options.baseClass}__selector--type`).val('');
    self.updateActiveFilters();
    self.updateVisiblePopups();

  });

};

// this function updates the active state of the filters
MapFloorPlansWithUnits.prototype.updateActiveFilters = function () {

  var self = this;

  this.options.$el.find(`.${self.options.baseClass}__selector--availability, .${self.options.baseClass}__selector--type`).each(function () {

    // update the state of this selector to show if it's active
    if ($(this).val()) {
      $(this).addClass(`${self.options.baseClass}__selector--selected`);
    } else {
      $(this).removeClass(`${self.options.baseClass}__selector--selected`);
    }

  });

};

// this function filters the markers, and then runs the animations to show the correct markers
MapFloorPlansWithUnits.prototype.updateVisiblePopups = function () {

  var self = this;
  var filteredPopupMarkers = self.getFilteredPopupMarkers();

  self.popupMarkersInOut(filteredPopupMarkers.hide, filteredPopupMarkers.show);

};

// This filters through the popup markers, and returns the ones that should be visible and the ones that should be hidden
MapFloorPlansWithUnits.prototype.getFilteredPopupMarkers = function () {

  var self = this;

  var floorFilterValue = this.options.$el.find(`.${self.options.baseClass}__selector--floor`).val();
  var availabilityFilterValue = this.options.$el.find(`.${self.options.baseClass}__selector--availability`).val();
  var bedsFilterValue = this.options.$el.find(`.${self.options.baseClass}__selector--type`).val();

  var popupMarkersToShow = [];
  var popupMarkersToHide = [];

  for (let i = 0; i < this.$allPopupMarkers.length; i++) {

    var $currentMarker = this.$allPopupMarkers.eq(i);

    if (floorFilterValue && $currentMarker.data('floor').toString().toLowerCase() != floorFilterValue.toString().toLowerCase()) {
      popupMarkersToHide.push($currentMarker);
    } else if (bedsFilterValue && $currentMarker.data('beds').toString().toLowerCase() != bedsFilterValue.toString().toLowerCase()) {
      popupMarkersToHide.push($currentMarker);
    } else if (availabilityFilterValue && $currentMarker.data('available').toString().toLowerCase() != availabilityFilterValue.toString().toLowerCase()) {
      popupMarkersToHide.push($currentMarker);
    } else {
      popupMarkersToShow.push($currentMarker);
    }

  }


  return {
    show: popupMarkersToShow,
    hide: popupMarkersToHide
  };

};

// This function takes an array of popup markers to hide and array of popup markers to show.
// It then hides any currently visible markers that should be hidden, and shows any currently hidden markers that should be visible.
// This is necessary so that gsap can get the timings right.
MapFloorPlansWithUnits.prototype.popupMarkersInOut = function ($popupMarkersToHide, $popupMarkersToShow) {

  var self = this;

  var $popupMarkersToAnimateIn = [];
  var $popupMarkersToAnimateOut = [];

  // this loop goes through all the markers that should be hidden, and finds the ones that are currently visible
  for (let i = 0; i < $popupMarkersToHide.length; i++) {

    let markerId = $popupMarkersToHide[i].data('popupId');

    let visibleMarkerIndex = this.visiblePopupMarkerIds.indexOf(markerId);

    // if this marker is currently visible
    if (visibleMarkerIndex > -1) {
      this.visiblePopupMarkerIds.splice(visibleMarkerIndex, 1); //remove from the visible id array
      this.hiddenPopupMarkerIds.push(markerId); // add id to hidden array
      $popupMarkersToAnimateOut.push($popupMarkersToHide[i]); // add to elements to be hidden
    }

  }

  // this loop goes through all the markers that should be shown, and finds the ones that are currently hidden
  for (let i = 0; i < $popupMarkersToShow.length; i++) {

    let markerId = $popupMarkersToShow[i].data('popupId');

    let hiddenMarkerIndex = this.hiddenPopupMarkerIds.indexOf(markerId);

    // if this marker is currently hidden
    if (hiddenMarkerIndex > -1) {
      this.hiddenPopupMarkerIds.splice(hiddenMarkerIndex, 1); // remove from the hidden id array
      this.visiblePopupMarkerIds.push(markerId); // add id to visible id array
      $popupMarkersToAnimateIn.push($popupMarkersToShow[i]); // add to elements to be shown
    }

  }

  // run our animations
  gsap.timeline()
    .to($popupMarkersToAnimateOut, {
      duration: 0.4,
      opacity: 0,
      scale: 0,
      yPercent: 25,
      stagger: {
        each: 0.08
      }
    })
    .to($popupMarkersToAnimateIn, {
      duration: 0.4,
      opacity: 1,
      scale: 1,
      yPercent: -50,
      stagger: {
        each: 0.08
      }
      //ease: "power1.out",
    }, ">-0.32");

};

// this function waits until the modal is loaded, and then shows the modal
MapFloorPlansWithUnits.prototype.showUnitModalWhenLoaded = function (unitId) {

  var self = this;

  if (!window.modalUnitDetailLoaded) {

    setTimeout(function () {
      self.showUnitModalWhenLoaded(unitId);
    }, 50);

  } else {

    self.showUnitModal(unitId);

  }

};

// this function changes the floor that is currently shown
MapFloorPlansWithUnits.prototype.goToFloor = function (floorId) {

  var self = this;

  // kill our animation in case it's still running from before
  if (this.goToFloorTimeline) {
    this.goToFloorTimeline.progress(1);
  }

  var $allPopupMarkers = self.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`);

  var $oldActiveImage = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${self.activeFloor}"] .${self.options.baseClass}__floorPlanImage`);
  var $oldActiveContainer = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${self.activeFloor}"]`);
  var $oldActiveFloorIcon = self.options.$el.find(`.${self.options.baseClass}__floorIndicator__floors__floor--active`);
  var $inactiveFloorNames = self.options.$el.find(`.${self.options.baseClass}__floorIndicator__floorNames__floorName:not([data-floor="${floorId}"])`);

  var $newActiveImage = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floorId}"] .${self.options.baseClass}__floorPlanImage`);
  var $newActiveContainer = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floorId}"]`);
  var $newActivePopupMarkers = self.getFilteredPopupMarkers().show;
  var $newActiveFloorIcon = self.options.$el.find(`.${self.options.baseClass}__floorIndicator__floors__floor[data-floor="${floorId}"]`);
  var $newActiveFloorName = self.options.$el.find(`.${self.options.baseClass}__floorIndicator__floorNames__floorName[data-floor="${floorId}"]`);

  this.goToFloorTimeline = gsap.timeline({
      defaults: {
        ease: "power1.out",
      }
    })
    // .timeScale(0.5)
    // we're handling colors using an active class so that we can keep all colors at the top of the scss file
    .add(function () {
      $oldActiveFloorIcon.removeClass(`${self.options.baseClass}__floorIndicator__floors__floor--active`);
      $newActiveFloorIcon.addClass(`${self.options.baseClass}__floorIndicator__floors__floor--active`);
    })
    // update newly active floor underline
    .to($inactiveFloorNames, {
        opacity: 0
      },
      "0"
    )
    .to($newActiveFloorName, {
        opacity: 1
      },
      "0"
    )
    // old image
    .fromTo($oldActiveImage, {
        opacity: 1,
      }, {
        duration: 0.3,
        opacity: 0
      },
      "0"
    )
    // old popup markers
    .to($allPopupMarkers, {
        duration: 0.3,
        opacity: 0,
      },
      "0"
    )
    .set($allPopupMarkers, {
        yPercent: 25,
        scale: 0
      },
      ">"
    )
    .add(function () {

      // set all the popups to hidden so that the filtering function will not try to hide them again later
      self.visiblePopupMarkerIds = [];
      self.hiddenPopupMarkerIds = [];

      for (let i = 0; i < self.$allPopupMarkers.length; i++) {
        let markerId = self.$allPopupMarkers.eq(i).data('popupId');
        self.hiddenPopupMarkerIds.push(markerId);
      }

    })
    .set($oldActiveContainer, {
        display: "none"
      },
      ">"
    )
    .addLabel("oldFloorPlanHidden", ">")
    // update newly active floor plan image
    .set($newActiveContainer, {
        display: "block"
      },
      "oldFloorPlanHidden"
    )
    .fromTo(self.options.$el, {
        height: self.options.$el.outerHeight()
      }, {
        duration: 0.3,
        height: "auto"
      },
      ">"
    )
    .addLabel("heightAdjusted", ">")
    .add(function () {
      self.positionUnitPopups(floorId);
    }, "heightAdjusted")
    // image
    .fromTo($newActiveImage, {
        scale: 1.05,
        opacity: 0
      }, {
        duration: 0.7,
        scale: 1,
        opacity: 1
      },
      "heightAdjusted"
    )
    // unit popup markers
    .set($newActivePopupMarkers, {
        xPercent: -50
      },
      "heightAdjusted"
    )
    .add(function () {
      self.updateVisiblePopups();
    }, "heightAdjusted")
    .add(function () {
      self.activeFloor = floorId;
    });
};

// this function animates in the component
MapFloorPlansWithUnits.prototype.animateIn = function () {

  var self = this;

  // animate in when component is in viewport
  gsap.timeline({
      scrollTrigger: {
        trigger: self.options.$el,
        start: '75% bottom',
        end: '50% top',
        // markers: true,
      },
      delay: 0,
    })
    .set(self.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`), {
      xPercent: -50
    })
    .to(self.options.$el.find(`.${self.options.baseClass}__floorPlanImage`), {
        duration: 0.7,
        ease: "power1.out",
        scale: 1,
        //ease: "power1.out",
      },
      "<"
    )
    .add(function () {
      self.updateVisiblePopups();
    }, "<");

};

// this function positions the unit popups, and initializes the events that will show the popups
MapFloorPlansWithUnits.prototype.initUnitPopups = function () {

  var self = this;

  this.positionUnitPopups(1);

  $(window).on('load', function () {
    self.positionUnitPopups(1);
  });

  PubSub.subscribe("resized", function () {
    self.positionUnitPopups(self.activeFloor);
  });

  this.options.$el.find(`.${self.options.baseClass}__unitPopupMarker`).on({

    // open popup on hover
    mouseenter: function () {

      if (Breakpoint.value == "medium" ||
        Breakpoint.value == "large" ||
        Breakpoint.value == "xlarge" ||
        Breakpoint.value == "xxlarge") {

        var $popup = $('#' + $(this).data('popupId'));
        self.showPopup($popup);

      }

    },

    // only close on mouse leave for large screens
    mouseleave: function () {

      if (Breakpoint.value == "medium" ||
        Breakpoint.value == "large" ||
        Breakpoint.value == "xlarge" ||
        Breakpoint.value == "xxlarge") {

        var $popup = $('#' + $(this).data('popupId'));
        self.hidePopup($popup);
      }

    },

    // react to click event
    click: function () {
      var unitId = $(this).data('unitId');
      self.showUnitModal(unitId);
    }

  });

  this.options.$el.find(`.${self.options.baseClass}__unitPopupWrapper`).on({

    // on hover, clear timeout that would close the popup, in case it's been triggered
    mouseenter: function () {

      if (Breakpoint.value == "medium" ||
        Breakpoint.value == "large" ||
        Breakpoint.value == "xlarge" ||
        Breakpoint.value == "xxlarge") {

        var $popup = $(this);
        if (self.activePopupId == $popup.attr('id')) {
          clearTimeout(self.hidePopupTimeout);
        }


      }

    },

    // only close on mouse leave for large screens
    mouseleave: function () {

      if (Breakpoint.value == "medium" ||
        Breakpoint.value == "large" ||
        Breakpoint.value == "xlarge" ||
        Breakpoint.value == "xxlarge") {

        self.hidePopup($(this));
      }

    }

  });

  // handle detail button clicks
  this.options.$el.find(`.${self.options.baseClass}__unitPopup__content__buttons__button--details`).on('click', function () {

    var unitId = $(this).data('unitId');

    self.showUnitModal(unitId);

  });

};

// Show popup shows the popup if it's not currently active. If it is active, it cancels the timeout that would've closed it.
MapFloorPlansWithUnits.prototype.showPopup = function ($popup) {

  var self = this;

  if (this.activePopupId != $popup.attr('id')) {

    this.activePopupId = $popup.attr('id');

    if (this.popupAnimation) {
      this.popupAnimation.progress(1);
    }

    this.popupAnimation = gsap.timeline({
        defaults: {
          ease: "power1.out",
        }
      })
      .set($popup, {
        zIndex: 4,
        visibility: "visible"
      })
      .fromTo($popup, {
        y: -10,
        opacity: 0
      }, {
        duration: 0.3,
        y: 0,
        opacity: 1
      });

  } else {
    // this is the currently active popup, so clear the timeout that would've closed it
    clearTimeout(this.hidePopupTimeout);
  }

};

MapFloorPlansWithUnits.prototype.hidePopup = function ($popup) {

  var self = this;

  this.hidePopupTimeout = window.setTimeout(function () {

    // if we're closing the currently active popup, set active popup to null
    if (self.activePopupId == $popup.attr('id')) {
      self.activePopupId = null;
    }

    if (self.popupAnimation) {
      self.popupAnimation.progress(1);
    }

    self.popupAnimation = gsap.timeline({
        defaults: {
          ease: "power1.out",
        }
      })
      .to($popup, {
        duration: 0.3,
        opacity: 0
      })
      .set($popup, {
        zIndex: -1,
        visibility: "hidden"
      });

  }, 280);

};

// this function takes a unit ID, and it queries for that unit's info and opens the modal
MapFloorPlansWithUnits.prototype.showUnitModal = function (unitId) {

  var self = this;

  // open up the modal in loading state
  PubSub.publish('ModalUnitDetail:open', unitId);

  // put together our graph ql query
  var query = `
	query MyQuery {
		entry(section: "units", id: "` + unitId + `", site: "*") {
			... on units_unit_Entry {
				id
				url
				unitActive
				unitBeds
				unitBaths
				unitSquareFeet
				unitCost
				title
				unitIntroText
        unitDescription
				unitApplicationFee
				unitSecurityDeposit
				unitPetPolicies {
					... on unitPetPolicies_petPolicy_BlockType {
						petPolicyText
					}
				}
				unitAvailability
				unitAmenities {
					... on unitAmenities_amenity_BlockType {
						amenityText
					}
				}
				unitApplyUrl
				unitYoutubeVideoId
				unitImages {
				  	url @transform(width: 960, height: 540, immediately: true)
				}
				unitFloorPlanImage {
				  url
				}
				unitFloorPlan {
				  ...on floorPlans_floorPlan_Entry {
				    floorPlanSummaryText
				  }
				}
			}
		}
	}
	`;

  // run the ajax query that gets our unit data
  $.ajax({

    type: 'POST',
    url: '/api',
    data: {
      query: query
    },

    success: function (data) {

      // console.log(data.data.entry);

      if (!data.data.entry) {
        PubSub.publish('ModalUnitDetail:notFound');
        return;
      }

      PubSub.publish('ModalUnitDetail:populateContent', data.data.entry);

      // var entry = data.data.entry;

      // var imageUrls = [];
      // for (var i = 0; i < entry.projectFeaturedImages.length; i++)
      // {
      // 	imageUrls.push(entry.projectFeaturedImages[i].url);
      // }

      // var title = entry.title;;
      // var textContent = entry.projectSummary;
      // var url = entry.url;

      // // populate the pane, if it's active then wait until fade out to populate
      // window.setTimeout(function() {
      // 	self.populateDetailPane(imageUrls, title, textContent, url);
      // }, 300);

    },

    error: function (data) {
      console.log('ajax error');
      console.log(data);
    },

  });

};

// this function positions the unit popups
MapFloorPlansWithUnits.prototype.positionUnitPopups = function (floor) {

  var self = this;

  this.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floor}"] .${self.options.baseClass}__unitPopupWrapper`).each(function () {

    var $popupMarker = $(this).prev();

    // reset everything
    $(this).find(`.${self.options.baseClass}__unitPopupWrapper__arrow`).css('left', '');
    $(this).removeClass(`${self.options.baseClass}__unitPopupWrapper--arrowFlipped`);
    $(this).css({
      'left': '',
      'top': '',
    });
    $(this).find(`.${self.options.baseClass}__unitPopupWrapper__arrow`).css({
      'left': '',
    });

    if (Breakpoint.value == "medium" ||
      Breakpoint.value == "large" ||
      Breakpoint.value == "xlarge" ||
      Breakpoint.value == "xxlarge") {
      // get our bounding rectangles
      var heightContainerBoundingRect = self.options.$el[0].getBoundingClientRect();
      var containerBoundingRect = self.options.$el[0].getBoundingClientRect();
      // var containerBoundingRect = self.options.$el.find(`.${self.options.baseClass}__floorPlanImageContainer[data-floor-id="${floor}"]`)[0].getBoundingClientRect();

      var popupBoundingRect = $(this)[0].getBoundingClientRect();

      var popupTopAdjust = popupBoundingRect.height - 6 + ($popupMarker.outerHeight() / 2); // subtract 6 so popup intersects marker
      var popupHalfWidth = popupBoundingRect.width / 2; // 

      // initial popup position
      $(this).css({
        'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px)',
        'top': 'calc(' + $(this).data('y') + '% - ' + popupTopAdjust + 'px)',
      });

      // after initial positioning, update the popup bounding rectangle
      popupBoundingRect = $(this)[0].getBoundingClientRect();

      // make sure our popup is still contained inside the component

      // left side
      if (popupBoundingRect.left < containerBoundingRect.left) {

        // the popup is outside the left edge, adjust to move it back in
        var leftAdjust = containerBoundingRect.left - popupBoundingRect.left + 6;

        $(this).css({
          'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px + ' + leftAdjust + 'px)',
        });

        // adjust the arrow so it still points to the marker
        $(this).find(`.${self.options.baseClass}__unitPopupWrapper__arrow`).css({
          'left': 'calc(50% - 14px - ' + leftAdjust + 'px)',
        });

      }

      // right side
      if (popupBoundingRect.right > containerBoundingRect.right) {

        // the popup is outside the right edge, adjust to move it back in
        var rightAdjust = popupBoundingRect.right - containerBoundingRect.right + 6;

        $(this).css({
          'left': 'calc(' + $(this).data('x') + '% - ' + popupHalfWidth + 'px - ' + rightAdjust + 'px)',
        });

        // adjust the arrow so it still points to the marker
        $(this).find(`.${self.options.baseClass}__unitPopupWrapper__arrow`).css({
          'left': 'calc(50% - 14px + ' + rightAdjust + 'px)',
        });

      }

      // top
      if ((popupBoundingRect.top - 20) < heightContainerBoundingRect.top) // subtract ten from bounding rect to account for translateY
      {

        // the popup is outside the top edge, adjust to move it back in

        // flip the arrow so it points up
        $(this).addClass(`${self.options.baseClass}__unitPopupWrapper--arrowFlipped`);

        var popupTopAdjust = ($popupMarker.outerHeight() / 2) - 6; // subtract 6 so popup intersects marker

        // use percentage, pull down 8px to give some space around marker
        $(this).css({
          'top': 'calc(' + $(this).data('y') + '% + ' + popupTopAdjust + 'px)',
        });

      }

    }

  });

};

export default MapFloorPlansWithUnits;